import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const AutoConversionByLine: LoadableType<{}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AutoConversionByLine" */ '../src/AutoConversionByLine/AutoConversionByLineComponent.tsx'
			)
		).AutoConversionByLine,
	name: 'AutoConversionByLine',
});
